// @ngInject
export function selectRange($parse: ng.IParseService): ng.IDirective {
  let setCaretPosition = (element: any, caretPos: number) => {
    if (element) {
      if (element.setSelectionRange) {
        element.setSelectionRange(element.value.length - caretPos, element.value.length);
        element.focus();
      }
    }
  };

  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any) {
      let model = attrs.selectRangeKey ? $parse(attrs.selectRangeKey) : $parse(attrs.selectRange);
      scope.$watch(model, (value: number) => {
        value = attrs.selectRangeKey ? scope.$eval(attrs.selectRange) : value;
        if (value != 0) {
          setCaretPosition(element[0], value);
        }
      });
    }
  };
}
